// ** Reja
const initialRejaState = {}

const Reja = (state = initialRejaState, action) => {
  switch (action.type) {
    case "SET_REJA_TYPES_CONTENT":
      return { ...state, ...action.val }
    default:
      return state
  }
}

export default Reja
